var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#9CA3AF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 15.016C23 16.4667 22.6427 17.8053 21.928 19.032C21.2133 20.2587 20.2427 21.2293 19.016 21.944C17.7893 22.6587 16.4507 23.016 15 23.016C13.5493 23.016 12.2107 22.6587 10.984 21.944C9.75733 21.2293 8.78667 20.2587 8.072 19.032C7.35733 17.8053 7 16.4667 7 15.016C7 13.5653 7.35733 12.2267 8.072 11C8.78667 9.77332 9.75733 8.80266 10.984 8.08799C12.2107 7.37332 13.5493 7.01599 15 7.01599C16.4507 7.01599 17.7893 7.37332 19.016 8.08799C20.2427 8.80266 21.2133 9.77332 21.928 11C22.6427 12.2267 23 13.5653 23 15.016ZM21.128 15.016C21.128 13.3307 20.528 11.888 19.328 10.688C18.128 9.48799 16.6853 8.88799 15 8.88799C13.656 8.88799 12.4507 9.28266 11.384 10.072L19.944 18.632C20.7333 17.5653 21.128 16.36 21.128 15.016ZM18.616 19.96L10.056 11.4C9.26667 12.4667 8.872 13.672 8.872 15.016C8.872 16.7013 9.472 18.144 10.672 19.344C11.872 20.544 13.3147 21.144 15 21.144C16.344 21.144 17.5493 20.7493 18.616 19.96Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.506c0d71a8c24f5b1a3390bbd1920780.svg";
export { ForwardRef as ReactComponent };